let html = `<div class="cub-premium">
    <div class="cub-premium__title">CUB Premium</div>
    <div class="cub-premium__descr">
        #{account_premium}
    </div>
    <div class="cub-premium__descr">#{account_premium_more}</div>
    <div class="cub-premium__url">{site}/premium</div>
</div>`

export default html